export const ROLES = {
  SUPER_ADMIN: "SUPER_ADMIN",
  MANAGER: "MANAGER",
  SUPERVISOR: "SUPERVISOR",
  WAITER: "WAITER",
  KITCHEN: "KITCHEN",
} as const;

export type Role = (typeof ROLES)[keyof typeof ROLES];

/** Staff roles a SUPER_ADMIN can provision for a business. */
export const TENANT_ROLES: Role[] = [ROLES.MANAGER, ROLES.SUPERVISOR, ROLES.WAITER, ROLES.KITCHEN];

/** Shops have no kitchen; their WAITER is the seller. */
export const SHOP_ROLES: Role[] = [ROLES.MANAGER, ROLES.SUPERVISOR, ROLES.WAITER];

/**
 * A role as people in that business call it: WAITER is "Seller" in a shop
 * and "Waiter" in a restaurant; with no business known, both.
 */
export function roleLabel(role?: string | null, businessType?: string | null): string {
  switch (role) {
    case "SUPER_ADMIN":
      return "Super admin";
    case "MANAGER":
      return "Manager";
    case "SUPERVISOR":
      return "Supervisor";
    case "KITCHEN":
      return "Kitchen";
    case "WAITER":
      if (!businessType) return "Waiter / Seller";
      return businessType === "RESTAURANT" ? "Waiter" : "Seller";
    default:
      return role ?? "—";
  }
}

/** This portal is platform-admin only — everyone lands on the platform dashboard. */
export function homeFor(_role?: string | null): string {
  return "/";
}
